var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCouleursActives(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21cm",
    height: "20cm",
    viewBox: "718 138 405 385",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 720,
    y: 140,
    width: 400,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 720,
    y: 140,
    width: 400,
    height: 380
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 760,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 760,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 800,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 800,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 840,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 840,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 880,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 880,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 920,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 920,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 960,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 960,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1000,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 1000,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1040,
    y: 260,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 1040,
    y: 260,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 780,
    y: 245.875
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 780,
    y: 245.875
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 820,
    y: 245.875
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 820,
    y: 245.875
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 900,
    y: 245.875
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 900,
    y: 245.875
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 940,
    y: 245.875
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 940,
    y: 245.875
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 980,
    y: 245.875
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 980,
    y: 245.875
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 860,
    y: 245.875
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 860,
    y: 245.875
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1020,
    y: 245.875
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1020,
    y: 245.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1060,
    y: 245.875
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 1060,
    y: 245.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 780,
    y: 285.628
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 780,
    y: 285.628
  }, "I"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 940,
    y: 285.628
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 940,
    y: 285.628
  }, "I"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 820,
    y: 285.628
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 820,
    y: 285.628
  }, "B"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 980,
    y: 285.628
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 980,
    y: 285.628
  }, "B"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 860,
    y: 285.628
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 860,
    y: 285.628
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1020,
    y: 285.628
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1020,
    y: 285.628
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 900,
    y: 285.628
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 900,
    y: 285.628
  }, "R"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1060,
    y: 285.628
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 1060,
    y: 285.628
  }, "R"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 840,
    y: 425.875
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 840,
    y: 425.875
  }, "I"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 840,
    y: 445.875
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 840,
    y: 445.875
  }, "B"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 840,
    y: 465.875
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 840,
    y: 465.875
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 840,
    y: 485.875
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 840,
    y: 485.875
  }, "R"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 870,
    y1: 420,
    x2: 890.264,
    y2: 420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 860,
    y1: 420,
    x2: 862,
    y2: 420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 863.333,
    y1: 420,
    x2: 865.333,
    y2: 420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 866.667,
    y1: 420,
    x2: 868.667,
    y2: 420
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "897.764,420 887.764,425 890.264,420 887.764,415 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "897.764,420 887.764,425 890.264,420 887.764,415 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 870,
    y1: 440,
    x2: 890.264,
    y2: 440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 860,
    y1: 440,
    x2: 862,
    y2: 440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 863.333,
    y1: 440,
    x2: 865.333,
    y2: 440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 866.667,
    y1: 440,
    x2: 868.667,
    y2: 440
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "897.764,440 887.764,445 890.264,440 887.764,435 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "897.764,440 887.764,445 890.264,440 887.764,435 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 870,
    y1: 460,
    x2: 890.264,
    y2: 460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 860,
    y1: 460,
    x2: 862,
    y2: 460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 863.333,
    y1: 460,
    x2: 865.333,
    y2: 460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 866.667,
    y1: 460,
    x2: 868.667,
    y2: 460
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "897.764,460 887.764,465 890.264,460 887.764,455 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "897.764,460 887.764,465 890.264,460 887.764,455 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 870,
    y1: 480,
    x2: 890.264,
    y2: 480
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 860,
    y1: 480,
    x2: 862,
    y2: 480
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 863.333,
    y1: 480,
    x2: 865.333,
    y2: 480
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 866.667,
    y1: 480,
    x2: 868.667,
    y2: 480
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "897.764,480 887.764,485 890.264,480 887.764,475 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "897.764,480 887.764,485 890.264,480 887.764,475 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 920,
    y: 425.875
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 920,
    y: 425.875
  }, "Incrustation"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 920,
    y: 445.875
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 920,
    y: 445.875
  }, "Bleu"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 920,
    y: 465.875
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 920,
    y: 465.875
  }, "Vert"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 920,
    y: 485.875
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 920,
    y: 485.875
  }, "Rouge"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 39.5111,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 920,
    y: 196.65
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 920,
    y: 196.65
  }, "DOR"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 760,
    y1: 320,
    x2: 760,
    y2: 310
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 760,
    y1: 300,
    x2: 760,
    y2: 302
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 760,
    y1: 303.333,
    x2: 760,
    y2: 305.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 760,
    y1: 306.667,
    x2: 760,
    y2: 308.667
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 920,
    y1: 320,
    x2: 920,
    y2: 310
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 920,
    y1: 300,
    x2: 920,
    y2: 302
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 920,
    y1: 303.333,
    x2: 920,
    y2: 305.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 920,
    y1: 306.667,
    x2: 920,
    y2: 308.667
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1080,
    y1: 320,
    x2: 1080,
    y2: 310
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1080,
    y1: 300,
    x2: 1080,
    y2: 302
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1080,
    y1: 303.333,
    x2: 1080,
    y2: 305.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1080,
    y1: 306.667,
    x2: 1080,
    y2: 308.667
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 760,
    y1: 320,
    x2: 1080,
    y2: 320
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 840,
    y1: 320,
    x2: 840,
    y2: 348.028
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "840,355.528 835,345.528 840,348.028 845,345.528 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "840,355.528 835,345.528 840,348.028 845,345.528 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1000,
    y1: 320,
    x2: 1000,
    y2: 348.028
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1000,355.528 995,345.528 1000,348.028 1005,345.528 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1000,355.528 995,345.528 1000,348.028 1005,345.528 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 12.8,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1000,
    y: 380
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1000,
    y: 380
  }, "Couleur 0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 12.8,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 840,
    y: 380
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 840,
    y: 380
  }, "Couleur 1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouleursActives);
export default __webpack_public_path__ + "static/media/Couleurs_actives.de436752a7f908ec4d2c97ecda369e89.svg";
export { ForwardRef as ReactComponent };